/* eslint-disable max-len */
import { FC } from 'react';
import cx from 'clsx';

// types
import { IGlyphIcon } from './shared';

// styles
import { useStyles } from './shared/styles';

const BookmarkedFilled: FC<IGlyphIcon> = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M15 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H15.5C15.6326 20 15.7598 19.9473 15.8536 19.8536C15.9473 19.7598 16 19.6326 16 19.5V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0ZM2 17C2 16.7348 2.10536 16.4804 2.29289 16.2929C2.48043 16.1054 2.73478 16 3 16H14V18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17ZM8 9.5C8.00105 9.59126 7.97711 9.68106 7.93077 9.75969C7.88442 9.83831 7.81744 9.90274 7.73708 9.94601C7.65673 9.98928 7.56606 10.0097 7.47491 10.0051C7.38376 10.0006 7.29561 9.97111 7.22 9.92L5.28 8.62C5.19638 8.56657 5.09923 8.53818 5 8.53818C4.90077 8.53818 4.80362 8.56657 4.72 8.62L2.78 9.92C2.70439 9.97111 2.61624 10.0006 2.52509 10.0051C2.43394 10.0097 2.34327 9.98928 2.26292 9.94601C2.18256 9.90274 2.11558 9.83831 2.06923 9.75969C2.02289 9.68106 1.99895 9.59126 2 9.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H7.5C7.63261 2 7.75979 2.05268 7.85355 2.14645C7.94732 2.24021 8 2.36739 8 2.5V9.5Z"
        fill={color}
      />
    </svg>
  );
};

export default BookmarkedFilled;
